/**
 * Created by Jan on 21.02.2017.
 */

// Taken from http://stackoverflow.com/questions/280634/endswith-in-javascript
if (typeof  String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

// Taken from https://developer.mozilla.org/cs/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
if (!String.prototype.startsWith) {
    /**
     *
     * @param {string} searchString
     * @param {int=0} position
     * @returns {boolean}
     */
    String.prototype.startsWith = function(searchString, position){
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

/*
|-------------------------------------------------------------------------------------------------------------------
| Non-standard fills
|-------------------------------------------------------------------------------------------------------------------
| Even though those methods are not a part of the ES standard, they are deemed important or natural enough to justify 
| adding them this way.
*/


/**
 * Sources:
 * - http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 * - http://stackoverflow.com/a/7616484/5500468
 */
if (!String.prototype.hashCode) {

    /**
     * Provides the hash code of given string.
     *
     * This implementation is identical to Java's internal hashCode function.
     * 
     * @returns {number}
     */
    String.prototype.hashCode = function() {
        var hash = 0, i, chr, len;
        if (this.length === 0) return hash;
        for (i = 0, len = this.length; i < len; i++) {
            chr   = this.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };
}